// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".arrow-left[data-v-3e2fc138],.arrow-right[data-v-3e2fc138]{position:fixed;top:50%;cursor:pointer;transition:left .5s ease,right .5s ease;z-index:20;margin-top:-32px}.arrow-left[data-v-3e2fc138]{border-radius:0 100px 100px 0;left:0}.arrow-right[data-v-3e2fc138]{border-radius:100px 0 0 100px;right:0}.hidden-left[data-v-3e2fc138]{left:-32px}.hidden-right[data-v-3e2fc138]{right:-32px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
